const toastsBtn = document.querySelectorAll(".toast-btn");
const toasts = document.querySelectorAll(".toast");

if (toastsBtn) {
  toastsBtn.forEach((item, index) => {
    item.addEventListener("click", (e) => {
      e.preventDefault();
      toasts[index].classList.add("show");
      setTimeout(() => {
        toasts[index].classList.remove("show");
        const linkUrl = item?.getAttribute("href");
        if (linkUrl) {
          window.location.href = linkUrl;
        }
      }, 3000);
    });
  });
}
